/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_fa262744"]'><cube-slider :show-value="(true)" @change='(e)=>__invoke(e, [["handleChange"]])' @changing='(e)=>__invoke(e, [["handleChanging"]])'></cube-slider></div></template>
/* styles */
/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_fa262744"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_fa262744"}
  /** script content **/
  require("./slider-value.mpx.js?isComponent&outputPath=components%2Fslider-valuefa262744%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./slider-value.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fslider-valuefa262744%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_fa262744"],
    ctorType: "component",
    outputPath: "components/slider-valuefa262744/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-slider':getComponent(require("../../../packages/mpx-cube-ui/src/components/slider/index.mpx?isComponent&outputPath=components%2Findex999434b0%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>